module.exports = __webpack_public_path__ + "img/supervisor.d4ca40b2.png";